<template>
  <div class="app-table">
    <div v-if="!hideTitle">
      <div
        v-if="selected.length || tableTitle"
        class="table-title"
      >
        <div class="title-wrapper">
          <div
            v-if="tableTitle"
            class="title"
          >
            {{ tableTitle }}
          </div>

          <div
            v-if="selected.length && counterText"
            class="counter"
          >
            {{ select.length }} {{ counterText }}
          </div>
        </div>

        <span
          v-if="selected.length && showTableBtnHeader"
          @click="onDelete"
          class="selected-text"
        >
          {{ selectedText }}
        </span>
      </div>
    </div>

    <v-data-table
      v-model="select"
      v-bind="$attrs['custom-sort'] ? { 'custom-sort': $attrs['custom-sort'] } : {}"
      :item-key="itemKey"
      :items=" loading ? [] : items"
      :loading="loading"
      :headers="headersFiltered"
      :class="getClass"
      :select-all="selectAllCheckBox"
      :total-items="nativePagination ? undefined : 0"
      :pagination.sync="paginationSync"
      :rows-per-page-items="[rowsPerPageItems]"
      :no-data-text="loading ? 'Carregando' : 'Nenhum resultado encontrado'"
      @input="toggleSelect"
      flat
      hide-actions
      disable-initial-sort
    >
      <template
        slot="headerCell"
        slot-scope="props"
      >
        <v-tooltip
          v-if="props.header.tooltip && !props.header.tooltipIcon"
          top
        >
          <span
            slot="activator"
            class="table-header-text"
          >
            {{ props.header.text }}
          </span>
          <span>{{ props.header.tooltip }}</span>
        </v-tooltip>
        <span
          v-if="!props.header.tooltip || props.header.tooltipIcon"
          v-html="props.header.text"
          class="table-header-text"
        />
        <v-tooltip
          v-if="props.header.tooltipIcon"
          top
        >
          <v-icon
            slot="activator"
            small
          >
            {{ props.header.tooltipIcon }}
          </v-icon>
          <span v-html="props.header.tooltip" />
        </v-tooltip>
      </template>

      <template
        slot="items"
        slot-scope="props"
      >
        <tr
          v-if="!loading"
          :class="getRowClass(props.item)"
          :key="props.item._id"
        >
          <td v-if="checkboxTable">
            <v-checkbox
              v-if="!props.item.disabled"
              v-model="props.selected"
              :input-value="props.selected"
              :value="true"
              :value-comparator="() => !!props.selected"
              @change="selectPropsIfCan($event, props)"
              primary
              hide-details
            />
            <span
              v-else
              class="checkbox-disabled"
            />
          </td>

          <td
            v-for="(header, index) in headers.filter(header =>
              typeof header.show === 'boolean' ? header.show : true
            )"
            :key="index"
            :class="getTableDataStyle(header, props)"
            @click="onAction(header, props.item)"
            class="text-xs-left"
          >
            <!-- TODO: move onAction to icon -->
            <div class="td-icon">
              <v-icon
                slot="activator"
                v-if="header.icon"
                :style="styleCombo"
                :class="iconClasses(header, props)"
                @click.stop="onActionIcon(header, props.item)"
              >
                {{ header.icon(props.item).type }}
              </v-icon>

              <v-tooltip
                v-if="!isOption(header) && !!header.formatter && !header.inputWithNoDataBind"
                bottom
              >
                <template slot="activator">
                  <span
                    v-if="header.vHtml"
                    v-html="header.formatter(props.item)"
                    :style="getWidth(header)"
                  />
                  <span
                    v-else
                    :style="getWidth(header)">
                    {{ header.formatter(props.item) }}
                  </span>
                </template>
                <span v-html="header.formatter(props.item)" />
              </v-tooltip>
            </div>

            <v-progress-linear
              v-if="header.progress"
              :value="header.progress(props.item)"
              background-color="#E0E0E0"
              color="#299D8D"
            />

            <div
              v-if="header.toggle"
            >
              <v-switch
                v-model="props.item[header.value]"
                @change="$emit('onToggle', props.item)"
                class="table-toggle"
                color="secondary"
              />
            </div>

            <div
              v-if="header.button"
            >
              <span
                @click.stop="$emit('onClick', props.item)"
                class="table-button"
                color="primary"
                flat
              >
                {{ header.buttonText(props.item) || header.buttonText }}
              </span>
            </div>

            <div
              v-if="header.input"
            >
              <div v-if="header.inputWithNoDataBind">
                <v-text-field
                  :type="header.type ? header.type : 'text'"
                  :value="props.item[header.value]"
                  v-model="props.item[header.value]"
                  @input="(event) => onInputTableChange(event, props.item, header)"
                />
              </div>
              <div v-else>
                <v-text-field
                  :type="header.type ? header.type : 'text'"
                  v-model="props.item[header.value]"
                  min=1
                />
              </div>
            </div>

            <v-menu
              v-if="hasOption(header, props.item)"
              :disabled="disableOptionsMenu(header, props.item)"
              origin="center center"
              transition="scale-transition"
              bottom
              left
            >
              <v-btn
                id="btn-more-vert-app-table"
                slot="activator"
                dark
                icon
              >
                <v-icon class="more-icon">
                  more_vert
                </v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(option, i) in header
                    .options(props.item)
                    .filter(option => option.show === undefined || option.show)"
                  :key="i"
                  :disabled="option.disabled"
                  @click="emit(option.method, props.item, props.index)"
                >
                  <v-list-tile-title v-bind:id="option.id">
                    {{ option.title }}
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div
      v-if="nativePagination && items.length > rowsPerPageItems"
      class="text-xs-center pt-2"
    >
      <v-pagination
        v-model="nativeCurrentPagination.page"
        @input="nativeInput"
        :length="nativePages"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'AppTable',
  props: {
    headers: {
      type: Array,
      default: () => []
    },
    customHeader: {
      type: Array,
      default: () => []
    },
    tableTitle: {
      type: String,
      default: ''
    },
    nativePagination: {
      type: Boolean,
      default: false
    },
    counterText: {
      type: String,
      default: ''
    },
    selectedText: {
      type: String,
      default: 'Excluir'
    },
    items: {
      type: Array,
      required: true
    },
    selected: {
      type: Array,
      default: () => []
    },
    className: {
      type: String,
      default: 'mb-3'
    },
    loading: {
      type: Boolean,
      default: false
    },
    checkboxTable: {
      type: Boolean,
      default: false
    },
    checkboxTableValidator: {
      type: Function,
      default: null
    },
    /**
     * Essa propriedade adiciona o checkbox para selecionar todos os items da tabela
     */
    selectAllCheckBox: {
      type: Boolean,
      deafult: false
    },
    styleCombo: {
      type: Object,
      default: () => {}
    },
    currentPagination: {
      type: Number,
      default: null
    },
    hideTitle: {
      type: Boolean,
      default: false
    },
    itemKey: {
      type: String,
      default: '_id'
    },
    noElevation: {
      type: Boolean,
      default: false
    },
    rowsPerPageItems: {
      type: Number,
      default: 10
    },
    showTableBtnHeader: {
      type: Boolean,
      default: true
    },
    rowClassFunction: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      paginationSync: {},
      loadingClass: '',
      nativeCurrentPagination: {
        descending: false,
        page: 1,
        rowsPerPage: this.rowsPerPageItems,
        sortBy: null,
        totalItems: 0
      },
      nativePages: 1,
      select: [],
      pagination: {
        rowsPerPage: this.rowsPerPageItems,
        sortBy: undefined
      },
      lastPagination: {
        sortBy: undefined,
        descending: false
      }
    }
  },
  watch: {
    paginationSync: {
      handler() {
        if (
          this.paginationSync.sortBy === this.lastPagination.sortBy &&
          this.paginationSync.descending === this.lastPagination.descending
        )
          return
        if (!this.paginationSync.sortBy && this.lastPagination.sortBy) {
          this.paginationSync.sortBy = this.lastPagination.sortBy
          this.paginationSync.descending = !this.lastPagination.descending
          return
        }
        if (this.currentPagination) {
          this.paginationSync.page = this.currentPagination
        }
        const sort = {
          sortBy: this.paginationSync.sortBy,
          sortOrder: this.paginationSync.descending ? -1 : 1
        }
        this.lastPagination = {
          sortBy: _.cloneDeep(this.paginationSync.sortBy),
          descending: _.cloneDeep(this.paginationSync.descending)
        }
        this.$emit('onSortable', sort)
      },
      immediate: false,
      deep: true
    },
    currentPagination: {
      immediate: true,
      deep: true,
      handler() {
        if (this.select.length) {
          if (this.select) return
          this.select = []
        }
        this.pagination.page = this.currentPagination
      }
    },
    items: {
      immediate: true,
      deep: true,
      handler() {
        if (this.items.length > this.rowsPerPageItems) {
          this.nativePages = Math.ceil(this.items.length / this.rowsPerPageItems)
        }
      }
    },
    selected: {
      immediate: true,
      deep: true,
      handler() {
        this.select = this.selected
      }
    },
    loading: {
      handler() {
        this.loadingClass = this.loading ? `${this.className} inside-loading` : ''
      }
    }
  },
  created() {
    this.lastPagination.sortBy = this.pagination.sortBy
    this.currentPaginationType()
  },
  computed: {
    headersFiltered() {
      const headers = Object.assign([], this.headers)
      // Caso seja uma tabela selecionável, porém sem o 'selectAll'
      // cria um header vazio para as colunas ficarem na posição correta
      if (!this.selectAllCheckBox && this.checkboxTable) {
        headers.unshift({
          text: '',
          value: 'check-hidden'
        })
      }
      return headers.filter(header => (typeof header.show === 'boolean' ? header.show : true))
    },
    getClass() {
      const classes = this.loading ? this.loadingClass : this.className
      const elevationClass = this.noElevation ? '' : 'table-elevation'
      return `${classes} ${elevationClass}`
    }
  },
  methods: {
    /**
     * @params selecteds
     * caso o usuário marque o checkbox de selecionar todos itens, é passado todos os itens da página atual
     * caso o usuário desmarque o checkbox de selecionar todos os itens, não é passado nada
     * caso o usuário selecione cada elemento da tabela separadamente, é passado TODOS os itens selecionados na tabela, independente da página
     */
    toggleSelect(selecteds) {
      const hasSelecteds = !!selecteds.length

      // verifica se algum item não foi selecionado
      const someItemsSelected = hasSelecteds && true

      if (someItemsSelected) {
        this.$emit('table:selected-item', this.filteredDoubleArrayValue(selecteds))
        return
      }

      if (!this.selectAllCheckBox)
        return

      // verifica se todos itens foram selecionados
      const allItemsSelected = hasSelecteds && this.items.every(item => selecteds.includes(item))
      if (allItemsSelected) {
        this.$emit('table:selected-all', this.items)

      } else {
        this.$emit('table:remove-selecteds', this.items)
      }
    },
    nativeInput(currentPage) {
      this.paginationSync.page = currentPage
    },
    currentPaginationType() {
      this.nativeCurrentPagination.totalItems = this.items.length
      this.paginationSync = this.nativePagination
        ? this.nativeCurrentPagination
        : this.pagination
    },
    getRowClass(item) {
      const classes = { '--is-selected': this.selected.some(({ _id }) => _id === item._id) }

      if (this.rowClassFunction) {
        const customClasses = this.rowClassFunction(item)
        Object.assign(classes, customClasses)
      }

      return classes
    },

    selectPropsIfCan(newValue, props) {
      this.$emit('isCurrentItemSelected', {
        selected: !!newValue,
        _id: props.item._id
      })
      if (!newValue) {
        props.selected = false
        return
      }
      if (this.checkboxTableValidator && !this.checkboxTableValidator(props.item)) {
        props.selected = false
        return
      }
      props.selected = true
    },
    iconClasses(header, props) {
      let iconColor = header.icon(props.item).iconColor
        ? `icon-${header.icon(props.item).iconColor}`
        : { 'primary--text': !this.selected.some(({ _id }) => _id === props.item._id) }

      return [`mr-1 ${header.icon(props.item).color}`, iconColor]
    },
    onAction(header, item) {
      const data = {
        header,
        item
      }
      this.$emit('onAction', data)
    },
    filteredDoubleArrayValue(array) {
      const filterdArray = _.uniqBy(array, '_id')
      return filterdArray
    },
    onActionIcon(header, item) {
      const eventName = header?.event
      if (!eventName) return
      const selected = this.selected.some(({ _id }) => _id === item._id)
      if (selected) return
      this.$emit(eventName, { header, item })
    },
    onDelete() {
      this.$emit('onDelete', this.select)
    },
    isOption({ value }) {
      return value === 'options'
    },
    hasOption({ value, options }, item) {
      return this.isOption({ value })
        && options(item).length
        && options(item).some(option => option.show !== false)
    },
    disableOptionsMenu({ options }, item) {
      return options(item).every(option => option.show === false)
    },
    emit(method, item, index) {
      // TODO: remove this event
      this.$emit('onOption', { method, item, index })
      this.$emit(method, item, index)
    },
    getWidth({ width = '200px' }) {
      const style = [
        `max-width: ${width}`,
        'white-space: nowrap',
        'overflow: hidden',
        'text-overflow: ellipsis',
        'display: block'
      ]
      return style.join(';')
    },
    getTableDataStyle(header, props) {
      const style = []

      if (header.color) {
        style.push(header.color(props.item))
      }

      if (header.hasEditModeStyle) {
        style.push('edit-mode-input-row')

        if (header.type && header.type === 'text') {
          style.push('edit-mode-text-type')
        }
      }

      return style.join(' ')
    },
    onInputTableChange(event, item, header) {
      this.$emit('onInputTableChange', event, item, header)
    }
  }
}
</script>
<style lang="stylus">
.more-icon
  color: var(--neutral-high-light) !important

.td-icon
  display: flex
  align-items: center

  .material-icons
    cursor: pointer

tbody
  color: var(--neutral-high-light)

.table-title
  display: flex
  justify-content: space-between
  align-items: center
  font-size: 14px
  color: #828282
  font-weight: 500
  padding: 12px 24px
  background: rgba(59, 123, 127, 0.12)

  .title-wrapper
    .title
      color: #868E96
      font-size: 18px !important

    .counter
      font-weight: 600
      color: var(--v-primary-base)

  .selected-text
    color: var(--v-primary-base)
    cursor: pointer
    font-size: 16px
    padding: 0.8rem 2rem
    font-weight: 600
    border-radius: 5px

    @media (max-width: 768px)
      display: none

.app-table
  .table-elevation
    .v-table__overflow
      box-shadow: 0 2px 10px rgba(0,0,0,.1), 0 0 2px rgba(0,0,0,.2)

  .v-table__overflow
    border-radius: 8px
    .v-input--selection-controls.v-input--is-label-active
      .v-icon
        color: var(--secondary-dark) !important

    .--is-selected
      background: rgba(59, 123, 127, 0.12)

      &:hover
        background: rgba(59, 123, 127, 0.12) !important

  .inside-loading > .v-table__overflow
    overflow-x hidden

  .table-toggle
    margin-bottom: -25px

  .table-header-text
    color: var(--neutral-high-light)

  .table-button
    display: inline-block;
    color: var(--secondary-dark)
    font-size: 14px;
    font-weight: 700;
    width: max-content;
    cursor: pointer;

.edit-mode
  tbody
    color: #BDBDBD !important
    font-weight: normal

  .edit-mode-text-type
    min-width: 150px

  .edit-mode-input-row
    border: 1px solid #9E9E9E

    .theme--light.v-text-field>.v-input__control>.v-input__slot
      &:before, &:after
        border: none

    .v-text-field__slot
      input
        color: #9E9E9E !important

.icon-green {
  color: #27AE60 !important;
}

.icon-yellow {
  color: #FF9800 !important;
}

.icon-red {
  color: #EB5757 !important;
}
.checkbox-disabled {
  display: flex;
  background-color: var(--neutral-low-dark);
  width: 18px;
  height: 18px;
  border-radius: 1px;
  margin-left: 4px;
}

.row-production-active {
  background-color: rgba(235, 87, 87, 0.1) !important;
  border-left: 4px solid #EB5757 !important;
}

.row-production-inactive {
  background-color: rgba(255, 152, 0, 0.1) !important;
  border-left: 4px solid #FF9800 !important;
}
</style>
